import {useDispatch, useSelector} from 'react-redux';
import SomethingWentWrong from './ErrorBoundary/SomethingWentWrong/SomethingWentWrong';
import {useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {handleClearPageError, logout} from 'redux/store/auth';
import {toast} from 'react-toastify';

const PageErrorBoundary = props => {
  const pageError = useSelector(state => state.auth.pageError);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(handleClearPageError());
  }, [location]);

  if (pageError?.message === 'AUTHENTICATION_ERROR') {
    toast.error('Authorization Error: You need to login to access this page');
    navigate('/');
    dispatch(logout());
    dispatch(handleClearPageError());
    return;
  }

  if (pageError?.statusCode === 401) {
    return <SomethingWentWrong />;
  }

  if (pageError) {
    return (
      <SomethingWentWrong
        title="You do not have access to this page"
        message="You do not have the admin permission to view this page kindly go back home or reach out to the admin"
      />
    );
  }
  return <div>{props.children}</div>;
};

export default PageErrorBoundary;
